import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "reference",
    "scheduleRecord",
    "scheduleColumn",
    "value",
    "unit",
    "timeframe",
    "hour",
    "preview",
  ];

  declare referenceTarget: HTMLSelectElement;
  declare scheduleRecordTarget: HTMLInputElement;
  declare scheduleColumnTarget: HTMLInputElement;
  declare valueTarget: HTMLInputElement;
  declare unitTarget: HTMLSelectElement;
  declare timeframeTarget: HTMLSelectElement;
  declare hourTarget: HTMLInputElement;
  declare previewTarget: HTMLElement;

  connect() {
    this.syncHiddenFields();
    this.updatePreview();
  }

  syncHiddenFields() {
    const combined = this.referenceTarget.value;
    if (!combined) return;

    const [record, column] = combined.split("|");
    this.scheduleRecordTarget.value = record;
    this.scheduleColumnTarget.value = column;
  }

  referenceChanged() {
    this.syncHiddenFields();
    this.updatePreview();
  }

  updatePreview() {
    const value = this.valueTarget.value || "…";
    const unitEl = this.unitTarget;
    const unitLabel =
      unitEl.options[unitEl.selectedIndex]?.text || "…";
    const timeframeEl = this.timeframeTarget;
    const timeframeLabel =
      timeframeEl.options[timeframeEl.selectedIndex]?.text || "…";
    const refEl = this.referenceTarget;
    const refLabel =
      refEl.options[refEl.selectedIndex]?.text || "…";
    const hour = this.hourTarget.value || "…";

    this.previewTarget.innerHTML =
      `Send this <strong>${value}</strong> <strong>${unitLabel}</strong> <strong>${timeframeLabel}</strong> the <strong>${refLabel}</strong> at <strong>${hour}:00</strong>`;
  }
}
